<template>
  <div>
    <div class="w3-row flow-margin-right">
      <div class="w3-col w3-quarter">
        <content-header v-bind:title="$t('accessControl')"></content-header>
      </div>
      <div
        class="
          w3-col
          w-20pc
          w3-right
          flow-content-actions-header flow-margin-bottom
          w3-margin-right
        "
      >
        <div class="w3-content flow-padding-top">
          <!-- This is the actions bar at the top of the page -->
          <div class="w3-row zero">
            <div class="w3-col w3-quarter">
              <span
                class="
                  fa fa-stack
                  w3-large
                  cursor-pointer
                  active
                  w3-ripple
                  flow-blue-color
                "
                @click="toggleFilterPanel"
                :title="openFilters ? $t('hideFilters') : $t('showFilters')"
              >
                <i
                  class="fa fa-stack-2x fa-circle w3-text-white"
                  v-bind:class="openFilters ? 'halo-text' : ''"
                ></i>
                <i
                  class="
                    fa fa-stack-1x fa-filter fa-inverse
                    flow-blue-color
                    w3-xlarge
                  "
                  v-bind:class="areFiltersActive ? 'active-notification' : ''"
                ></i>
              </span>
            </div>
            <div class="w3-col w3-quarter">
              <span
                class="
                  fa fa-stack
                  w3-large
                  cursor-pointer
                  active
                  w3-ripple
                  flow-blue-color
                "
                @click="openNewAccess"
                :title="$t('addNewAccess')"
              >
                <i class="fa fa-stack-2x fa-circle w3-text-white"></i>
                <i
                  class="
                    fa fa-stack-1x fa-plus fa-inverse
                    flow-blue-color
                    w3-xlarge
                  "
                ></i>
              </span>
            </div>
            <div class="w3-col w3-quarter">
              <span
                class="
                  fa fa-stack
                  w3-large
                  cursor-pointer
                  active
                  w3-ripple
                  flow-blue-color
                "
                @click="loadAccessList"
                :title="$t('refresh')"
              >
                <i class="fa fa-stack-2x fa-circle w3-text-white"></i>
                <i
                  class="
                    fa fa-stack-1x fa-sync-alt fa-inverse
                    flow-blue-color
                    w3-xlarge
                  "
                ></i>
              </span>
            </div>
            <div class="w3-col w3-quarter">
              <span
                class="
                  fa fa-stack
                  w3-large
                  cursor-pointer
                  active
                  w3-ripple
                  flow-blue-color
                "
                @click="quickPrint"
                :title="$t('quickPrint')"
              >
                <i class="fa fa-stack-2x fa-circle w3-text-white"></i>
                <i
                  class="
                    fa fa-stack-1x fa-print fa-inverse
                    flow-blue-color
                    w3-xlarge
                  "
                ></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENT START -->
    <div
      v-bind:class="
        isEditWindowOpen
          ? 'w3-container content-sidebars sidebars-70-30'
          : 'w3-container flow-main-content'
      "
    >
      <access-filters
        :searchWithFilters="searchWithFilters"
        :defaultSearch = "loadAccessList"
        v-bind:class="openFilters ? 'w3-show' : 'w3-hide'"
        class="w3-margin-bottom w3-animate-opacity green-top"
      ></access-filters>

      <div
        class="
          w3-white w3-striped w3-margin-bottom
          zero-top
          flow-card
          blue-top
          w3-animate-opacity
        "
        id="access-table"
      >
        <!-- MAIN CONTENT CARD START -->
        <div
          v-bind:class="
            isEditWindowOpen
              ? 'zero content-sidebar-left'
              : 'zero w3-row-padding'
          "
        >
          <table class="w3-table w3-striped w3-bordered flow-table">
            <thead class="">
              <tr>
                <th>{{ $t("person") }}</th>
                <th>{{ $t("AZHContact") }}</th>
                <th>{{ $t("dateInterval") }}</th>
                <th>{{ $t("contact") }}</th>
              </tr>
            </thead>
            <tbody v-if="!isPageLoading">
            <tr
              v-for="access in accessList"
              :key="access.id"
              @click="selectAccess(access)"
              class="cursor-pointer"
            >
              <td>
                <access-type-badge class="w3-show-inline-block flow-padding-right flow-padding-left" :access-type="access.accessType" :only-icon="true"></access-type-badge>
                <span class="flow-padding-left">{{ access.name }}</span>
              </td>
              <td>{{ access.hospitalContact }}</td>
              <td>{{ displayDate(access.start, access.end) }}</td>
              <td>
                {{ access.email }}<br v-if="access.email" />
                {{ access.mobile }}
              </td>
            </tr>
            </tbody>
          </table>
          <loading v-bind:dspin="isPageLoading"></loading>
        </div>

        <!-- Side content -->
        <div
          v-if="isEditWindowOpen"
          class="
            w3-col
            content-sidebar-right
            top-from-header
            w3-animate-right
            flow-padding-top
          "
        >
          <access-control-card
            class="flow-padding-top"
            :access="selectedAccess"
            :preSelectedAccessType="preSelectedAccessType"
            :onClose="onClose"
            :reload="loadAccessList"
            :openNewAccess="openNewAccess"
            :isQuickPrint ="isQuickPrint"
            :keepPrintOpen="keepPrintOpen"
            :endKeepPrintOpen ="endKeepPrintOpen"
            :openAndRetrieveAccess="openAndRetrieveAccess"
            :openAndRetrieveAndPrintAccess="openAndRetrieveAndPrintAccess"
          ></access-control-card>
        </div>
      </div>
      <!-- CONTENT END -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import ContentHeader from "../components/common/ContentHeader";
import Loading from "../components/common/Loading";
import User from "./User.vue";
import UserRole from "../components/common/UserRole";
import AccessControlCard from "../components/access-control/AccessControlCard";
import AccessFilters from "../components/access-control/AccessFilters";
import {EventBus} from "@/main";
import AccessTypeBadge from "@/components/access-control/AccessTypeBadge";

const frc = Vue.prototype.$frc;

export default {
  name: "access_control",
  components: {
    AccessTypeBadge,
    AccessFilters,
    AccessControlCard,
    UserRole,
    User,
    ContentHeader,
    Loading,
  },
  data: function () {
    return {
      accessList: [],
      isEditWindowOpen: false,
      selectedAccess: {},
      preSelectedAccessType: null,
      areFiltersActive: false,
      openFilters: false,
      isPageLoading: true,
      isQuickPrint: false,
      keepPrintOpen: false
    };
  },
  //TODO use computed properties to guarantee the filters and the side panel are mutually exclusive
  mounted() {
    var app = this;
    // Load only when the setting allows it
    frc.getApplicationSetting("UI", "enableACE").then(function (res) {
      if (false === res.data) {
        app.redirectToUnlicensed();
        return;
      }

      app.init();
    }).catch(function (ex) {
      app.redirectToUnlicensed();
    });
  },
  computed: {
    currentDay() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return (
        year.toString().padStart(4, "0") +
        "-" +
        month.toString().padStart(2, "0") +
        "-" +
        day.toString().padStart(2, "0")
      );
    },
  },
  methods: {
    init() {
      this.loadAccessList();
      EventBus.$on("selectedACType", this.selectAccess)
    },
    redirectToUnlicensed() {
      this.$router.push('problem?reason=unlicensed');
    },
    onClose(){
      this.isEditWindowOpen = false;
      this.isQuickPrint = false;
      this.keepPrintOpen=false;
      this.preSelectedAccessType = null;
    },
    endKeepPrintOpen(){
      this.keepPrintOpen=false;
    },
    displayDate: function (startDate, endDate) {
      if (startDate === endDate) {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = String(today.getFullYear());
        var todayString = yyyy + "-" + mm + "-" + dd;
        if (startDate === todayString) {
          return this.$t("today");
        } else return startDate + " - " + endDate;
      } else {
        return startDate + " - " + endDate;
      }
    },
    loadAccessList: function () {
      var app = this;
      var start = this.currentDay + "T23:59:59";
      var end = this.currentDay + "T00:00:00";

      app.searchWithFilters(null, start, end, null);
    },
    searchWithFilters(name, start, end, accessType) {
      var app = this;
      this.isPageLoading=true;
      frc
        .getAllAccessControlEntriesFiltered(name, start, end, accessType)
        .then((res) => {
          this.accessList = res.data;
          this.isPageLoading=false;
        }).catch((error) => {
          Vue.notifyError({title: app.$t("failedToFetchAccessEntries")})
          this.isPageLoading=false;
        });
    },
    selectAccess(access) {
      if(!access.accessControlId) this.preSelectedAccessType = access.id; // creating new access control
      this.selectedAccess = access;
      this.openFilters = false;
      this.isEditWindowOpen = true;
    },
    openNewAccess() {
      this.selectedAccess = {};
      this.openFilters = false;
      this.isEditWindowOpen = true;
    },
    toggleFilterPanel() {
      this.openFilters = !this.openFilters;
      this.isEditWindowOpen = false;
    },
    quickPrint() {
      this.openFilters=false;
      this.isEditWindowOpen=true;
      this.isQuickPrint = true;
    },
    openAndRetrieveAccess(accessControlId){
      var app = this;
      frc.getAccessControlForId(accessControlId).then(response => {
        app.selectAccess(response.data);
        app.loadAccessList();
      })
    },
    openAndRetrieveAndPrintAccess(accessControlId){
      var app = this;
      frc.getAccessControlForId(accessControlId).then(response => {
        app.selectAccess(response.data);
        app.loadAccessList();
        app.keepPrintOpen=true;
      })
    }
  },
};
</script>